import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { WaterIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { useStyles } from "../../useStyles";

export const ElectricBoilerForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_BOILER>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<WaterIcon />}
                content={
                    <p className={classes.label}>
                        Elektrische Warmwasseraufbereitung (Durchlauferhitzer)
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricBoiler.value.yes}
                        onChange={(ev) =>
                            setValues((values) => {
                                values.newConnectionElectricBoiler.value = {
                                    yes: ev.target.checked,
                                    no: !ev.target.checked,
                                };
                            })
                        }
                    />
                }
            />
        </Fragment>
    );
};
